import React, { FC } from 'react';
import styled from 'styled-components';

const StyledTable = styled.div`
  h3.system_equirements {
    text-align: center;
    margin-bottom: 10px;
    font-size: 1.2rem;
    font-weight: bold;
    color: #231815;
  }
  table.system_equirements {
    border-collapse: collapse;
    margin: 0 auto 20px;
    padding: 0;
    table-layout: fixed;
  }
  table.system_equirements tr {
    background-color: rgba(198, 158, 97, 0.2);
    padding: 10px;
    border-bottom: 2px solid #fff;
  }
  table.system_equirements th,
  table.system_equirements thead th {
    color: #fff;
    text-align: center;
    vertical-align: middle;
  }
  table.system_equirements th,
  table.system_equirements td {
    padding: 20px;
    border-right: 2px solid #fff;
    vertical-align: middle;
    text-align: center;
  }
  table.system_equirements td:first-child {
    width: 300px;
    text-align: left;
  }
  table.system_equirements th {
    font-size: 1.2rem;
    border: 1px solid #fff;
  }
  table.system_equirements thead tr {
    background-color: #c69e61;
    color: #fff;
  }
  table.system_equirements tbody th {
    color: #fff;
  }
`;

export type Props = {
  title?: string;
  columns: string[];
  dataList: string[][];
};

/**
 * テーブルで情報を表示するコンポーネント
 */
const Table: FC<Props> = ({ title, columns, dataList }) => {
  return (
    <StyledTable>
      {title && <h3 className="system_equirements">{title}</h3>}

      <table className="system_equirements">
        <thead>
          <tr>
            {columns.map((column) => (
              <th>{column}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {dataList.map((record) => (
            <tr>
              {record.map((data) => (
                <td>{data}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </StyledTable>
  );
};

export default Table;
